<template>
  <div class="pm-dialog-order-type">
    <div class="flex justify-center outer-area">
      <div
        class="vs-col candidate-list"
        v-for="(val, index) in getMasterList(columnKey)"
        :key="index"
      >
        <div class="flex justify-center">
          <!-- 開始前、進行中、終了 左側表示部分 -->
          <vs-button
            @click="changePresentProgressStatus(index)"
            :color="setColor(index)"
            class="candidate-item"
          >
            {{ val }}
          </vs-button>

          <!-- 開始前 右側表示部分 -->
          <div v-show="index === 0" class="time-input-area">
            <div class="text-input">--------------------------</div>
          </div>

          <!-- 進行中 右側表示部分 -->
          <div class="time-input-area" v-show="index === 1">
            <vs-input-number
              placeholder="----"
              v-model="progressAtYear"
              class="time-input"
              :min="0"
              :max="9999"
              :readonly="isProgressInputDisabled"
            />年
            <vs-input-number
              placeholder="--"
              v-model="progressAtMonth"
              class="time-input"
              :min="1"
              :max="12"
              :readonly="isProgressInputDisabled"
            />月
            <vs-input-number
              placeholder="--"
              v-model="progressAtDate"
              class="time-input"
              :min="1"
              :max="validDay(progressAtYear, progressAtMonth)"
              :readonly="isProgressInputDisabled"
            />日
            <vs-input-number
              placeholder="--"
              v-model="progressAtHour"
              class="time-input"
              :min="0"
              :max="23"
              :readonly="isProgressInputDisabled"
            />:
            <vs-input-number
              placeholder="--"
              v-model="progressAtMinutes"
              class="time-input"
              :min="0"
              :max="59"
              :readonly="isProgressInputDisabled"
            />
          </div>

          <!-- 終了 右側表示部分 -->
          <div class="time-input-area" v-show="index === 2">
            <vs-input-number
              placeholder="----"
              v-model="completeYear"
              class="time-input"
              :min="0"
              :max="9999"
              :readonly="isCompleteInputDisabled"
            />年
            <vs-input-number
              placeholder="--"
              v-model="completeMonth"
              class="time-input"
              :min="1"
              :max="12"
              :readonly="isCompleteInputDisabled"
            />月
            <vs-input-number
              placeholder="--"
              v-model="completeDate"
              class="time-input"
              :min="1"
              :max="validDay(completeYear, completeMonth)"
              :readonly="isCompleteInputDisabled"
            />日
            <vs-input-number
              placeholder="--"
              v-model="completeHour"
              class="time-input"
              :min="0"
              :max="23"
              :readonly="isCompleteInputDisabled"
            />:
            <vs-input-number
              placeholder="--"
              v-model="completeMinutes"
              class="time-input"
              :min="0"
              :max="59"
              :readonly="isCompleteInputDisabled"
            />
          </div>

          <!-- 中止 右側表示部分 -->
          <div class="time-input-area" v-show="index === 3">
            <vs-input-number
              placeholder="----"
              v-model="suspendAtYear"
              class="time-input"
              :min="0"
              :max="9999"
            />年
            <vs-input-number
              placeholder="--"
              v-model="suspendAtMonth"
              class="time-input"
              :min="1"
              :max="12"
            />月
            <vs-input-number
              placeholder="--"
              v-model="suspendAtDate"
              class="time-input"
              :min="1"
              :max="validDay(suspendAtYear, suspendAtMonth)"
            />日
            <vs-input-number
              placeholder="--"
              v-model="suspendAtHour"
              class="time-input"
              :min="0"
              :max="23"
            />:
            <vs-input-number
              placeholder="--"
              v-model="suspendAtMinutes"
              class="time-input"
              :min="0"
              :max="59"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button class="button" color="#2E87B9" @mousedown="closePopup">
        <span class="button-text">キャンセル</span>
      </vs-button>
      <vs-button
        class="button"
        color="#2E87B9"
        @mousedown="onSubmit(isUpdateTimeStamp)"
      >
        <span class="button-text">保存</span>
      </vs-button>
    </div>
  </div>
</template>

<script>
/*
 * 入出港予定一覧画面（白色ではなく黒色画面）で、オーダー種別を編集するためのコンポーネント
 * @parent CellSummaryDialog.vue
 * @props columnKey: String カラム名を特定するためのキー。const.jsのCOL_NAMEの中の、columnKey
 *        valueMap : String 現在表示している値。
 *        taskId: String 一覧画面で表示する一行のデータにふられたID
 *        getMasterList: プログレスのマスタを取得する関数
 *        closePopup: ポップアップを閉じる関数
 */

import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("gkmgPortMasterDestinationWork");
import moment from "moment-timezone";
import { COL_NAME } from "@/config/const";

export default {
  name: "O.DialogProgressInput",
  props: {
    columnKey: { type: String, required: true },
    valueMap: { type: Object, required: true },
    taskId: { type: String, required: true },
    getMasterList: { type: Function, required: true },
    closePopup: { type: Function, required: false },
  },
  data() {
    return {
      presentProgressStatus: String(this.valueMap.itSelf),

      isProgressInputDisabled: true,
      timeProgressAt: null,
      progressAtYear: null,
      progressAtMonth: null,
      progressAtDate: null,
      progressAtHour: null,
      progressAtMinutes: null,

      isCompleteInputDisabled: true,
      timeComplete: null,
      completeYear: null,
      completeMonth: null,
      completeDate: null,
      completeHour: null,
      completeMinutes: null,

      // 中止
      timeSuspendAt: null,
      suspendAtYear: null,
      suspendAtMonth: null,
      suspendAtDate: null,
      suspendAtHour: null,
      suspendAtMinutes: null,

      isUpdateTimeStamp: null,
    };
  },
  computed: {
    ...mapState({
      summaryDialogShowPopup: (state) => state.summaryDialogShowPopup,
    }),
    isValidProgressTime() {
      return (
        // !this.isProgressInputDisabled &&
        this.progressAtYear &&
        this.progressAtMonth &&
        this.progressAtDate &&
        this.progressAtHour &&
        this.progressAtMinutes
      );
    },
    isValidCompleteTime() {
      return (
        // !this.isCompleteInputDisabled &&
        this.completeYear &&
        this.completeMonth &&
        this.completeDate &&
        this.completeHour &&
        this.completeMinutes
      );
    },
    isValidSuspendTime() {
      return (
        this.suspendAtYear &&
        this.suspendAtMonth &&
        this.suspendAtDate &&
        this.suspendAtHour &&
        this.suspendAtMinutes
      );
    },
  },
  watch: {
    summaryDialogShowPopup() {
      if (this.summaryDialogShowPopup) {
        this.initData();
      }
    },
    progressAtYear() {
      const maxDay = this.validDay(this.progressAtYear, this.progressAtMonth);
      if (maxDay < this.progressAtDate) {
        this.progressAtDate = maxDay;
      }
    },
    progressAtMonth() {
      const maxDay = this.validDay(this.progressAtYear, this.progressAtMonth);
      if (maxDay < this.progressAtDate) {
        this.progressAtDate = maxDay;
      }
    },
    completeYear() {
      const maxDay = this.validDay(this.completeYear, this.completeMonth);
      if (maxDay < this.completeDate) {
        this.completeDate = maxDay;
      }
    },
    completeMonth() {
      const maxDay = this.validDay(this.completeYear, this.completeMonth);
      if (maxDay < this.completeDate) {
        this.completeDate = maxDay;
      }
    },
    suspendAtYear() {
      const maxDay = this.validDay(this.suspendAtYear, this.suspendAtMonth);
      if (maxDay < this.suspendAtDate) {
        this.suspendAtDate = maxDay;
      }
    },
    suspendAtMonth() {
      const maxDay = this.validDay(this.suspendAtYear, this.suspendAtMonth);
      if (maxDay < this.suspendAtDate) {
        this.suspendAtDate = maxDay;
      }
    },
  },
  methods: {
    validDay(y, m) {
      const year = Number(y);
      const month = Number(m);
      if (isNaN(year) || isNaN(month)) return 31;

      if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
        return 31;
      } else if ([4, 6, 9, 11].includes(month)) {
        return 30;
      } else if (month === 2) {
        if (this.isLeap(year)) {
          return 29;
        } else {
          return 28;
        }
      } else {
        return 31;
      }
    },
    isLeap(year) {
      /*
       * 閏年
       * １）西暦が４で割り切れる年は閏年
       * ２）１）の例外として、西暦年号が100で割り切れて400で割り切れない年は平年
       */
      if (year % 4 !== 0) {
        // 4で割り切れない場合は平年（28日）
        return false;
      } else {
        // 100で割り切れるが400で割り切れない場合は平年(false)。そうでなければ閏年(true)。
        return !(year % 100 === 0 && year % 400 !== 0);
      }
    },
    changePresentProgressStatus(index) {
      // 進行中時間が未入力の時に終了時刻を入力することはできない。
      if (
        index === 2 &&
        !this.progressAtYear &&
        !this.progressAtMonth &&
        !this.progressAtDate &&
        !this.progressAtHour &&
        !this.progressAtMinutes
      ) {
        return;
      }

      // index(htmlボタンの番号)は0スタート、マスタのIdは1スタートなので、index+1している
      this.presentProgressStatus = index + 1;
      if (String(this.presentProgressStatus) === "1") {
        // 開始前
        this.isProgressInputDisabled = true;
        this.isCompleteInputDisabled = true;
      } else if (String(this.presentProgressStatus) === "2") {
        // 進行中
        this.isProgressInputDisabled = false;
        this.isCompleteInputDisabled = true;
        if (!this.timeProgressAt) {
          this.progressAtYear = moment().local().format("YYYY");
          this.progressAtMonth = moment().local().format("MM");
          this.progressAtDate = moment().local().format("DD");
          this.progressAtHour = moment().local().format("HH");
          this.progressAtMinutes = moment().local().format("mm");
        }
      } else if (String(this.presentProgressStatus) === "3") {
        // 終了
        this.isProgressInputDisabled = false;
        this.isCompleteInputDisabled = false;
        if (!this.timeProgressAt) {
          this.progressAtYear = moment().local().format("YYYY");
          this.progressAtMonth = moment().local().format("MM");
          this.progressAtDate = moment().local().format("DD");
          this.progressAtHour = moment().local().format("HH");
          this.progressAtMinutes = moment().local().format("mm");
        }
        if (!this.timeComplete) {
          this.completeYear = moment().local().format("YYYY");
          this.completeMonth = moment().local().format("MM");
          this.completeDate = moment().local().format("DD");
          this.completeHour = moment().local().format("HH");
          this.completeMinutes = moment().local().format("mm");
        }
      } else if (String(this.presentProgressStatus) === "4") {
        // 中止
        this.isProgressInputDisabled = false;
        this.isCompleteInputDisabled = false;
        // 中止時間が未入力なら、現在時刻で初期値を入力
        if (!this.timeSuspendAt) {
          this.suspendAtYear = moment().local().format("YYYY");
          this.suspendAtMonth = moment().local().format("MM");
          this.suspendAtDate = moment().local().format("DD");
          this.suspendAtHour = moment().local().format("HH");
          this.suspendAtMinutes = moment().local().format("mm");
        }
      } else {
        this.isProgressInputDisabled = true;
        this.isCompleteInputDisabled = true;
      }
    },
    setColor(index) {
      // index(htmlボタンの番号)は0スタート、マスタのIdは1スタートなので、index+1している
      if (Number(this.presentProgressStatus) === Number(index) + 1) {
        const colorCode = COL_NAME.find(
          (el) => String(el.columnKey) === String(this.columnKey),
        ).color[this.presentProgressStatus];
        return colorCode;
      } else {
        return "#dbdbdb";
      }
    },
    initData() {
      this.presentProgressStatus = this.valueMap.itSelf
        ? this.valueMap.itSelf
        : null;
      this.timeProgressAt =
        this.valueMap.progress_time && this.valueMap.progress_time.progress_at
          ? moment(this.valueMap.progress_time.progress_at.seconds * 1000)
              .local()
              .format("YYYYMMDD HH:mm")
          : null;
      this.timeComplete =
        this.valueMap.progress_time && this.valueMap.progress_time.complete
          ? moment(this.valueMap.progress_time.complete.seconds * 1000)
              .local()
              .format("YYYYMMDD HH:mm")
          : null;
      this.timeSuspendAt =
        this.valueMap.progress_time && this.valueMap.progress_time.suspend_at
          ? moment(this.valueMap.progress_time.suspend_at.seconds * 1000)
              .local()
              .format("YYYYMMDD HH:mm")
          : null;

      this.progressAtYear = this.timeProgressAt
        ? this.timeProgressAt.slice(0, 4)
        : null;
      this.progressAtMonth = this.timeProgressAt
        ? this.timeProgressAt.slice(4, 6)
        : null;
      this.progressAtDate = this.timeProgressAt
        ? this.timeProgressAt.slice(6, 8)
        : null;
      this.progressAtHour = this.timeProgressAt
        ? this.timeProgressAt.slice(9, 11)
        : null;
      this.progressAtMinutes = this.timeProgressAt
        ? this.timeProgressAt.slice(12, 14)
        : null;

      this.completeYear = this.timeComplete
        ? this.timeComplete.slice(0, 4)
        : null;
      this.completeMonth = this.timeComplete
        ? this.timeComplete.slice(4, 6)
        : null;
      this.completeDate = this.timeComplete
        ? this.timeComplete.slice(6, 8)
        : null;
      this.completeHour = this.timeComplete
        ? this.timeComplete.slice(9, 11)
        : null;
      this.completeMinutes = this.timeComplete
        ? this.timeComplete.slice(12, 14)
        : null;

      this.suspendAtYear = this.timeSuspendAt
        ? this.timeSuspendAt.slice(0, 4)
        : null;
      this.suspendAtMonth = this.timeSuspendAt
        ? this.timeSuspendAt.slice(4, 6)
        : null;
      this.suspendAtDate = this.timeSuspendAt
        ? this.timeSuspendAt.slice(6, 8)
        : null;
      this.suspendAtHour = this.timeSuspendAt
        ? this.timeSuspendAt.slice(9, 11)
        : null;
      this.suspendAtMinutes = this.timeSuspendAt
        ? this.timeSuspendAt.slice(12, 14)
        : null;

      this.isUpdateTimeStamp =
        this.timeProgressAt ||
        (this.valueMap.changes && this.valueMap.changes[String(this.columnKey)])
          ? true
          : false;

      // 通常開始前、進行中、終了ボタン押下時に着火する関数で、ボタンのindex(0始まり)を引数に受け取ることを想定しているので、this.valueMap.itSelf-1している。
      this.changePresentProgressStatus(this.valueMap.itSelf - 1);
    },
    createTimeSubmitData() {
      const progressAtTime = `${this.progressAtYear}-${this.progressAtMonth}-${this.progressAtDate} ${this.progressAtHour}:${this.progressAtMinutes}:00`;
      const completeTime = `${this.completeYear}-${this.completeMonth}-${this.completeDate} ${this.completeHour}:${this.completeMinutes}:00`;
      const suspendTime = `${this.suspendAtYear}-${this.suspendAtMonth}-${this.suspendAtDate} ${this.suspendAtHour}:${this.suspendAtMinutes}:00`;
      return {
        ...(this.isValidProgressTime
          ? { progress_at: new Date(progressAtTime) }
          : {}), // 進行中
        ...(this.isValidCompleteTime
          ? { complete: new Date(completeTime) }
          : {}), // 終了
        ...(this.isValidSuspendTime
          ? { suspend_at: new Date(suspendTime) }
          : {}), // 中止
      };
    },
    onSubmit(isUpdateTimeStamp) {
      /*
       * onSubmit(false)    : 保存
       * onSubmit(true)     : ハイライト保存
       */
      const mode = [];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp");
      const updateKeyValueMap = {};

      const submitData = this.createTimeSubmitData();

      updateKeyValueMap["progress_time"] = submitData;
      updateKeyValueMap["progress"] = this.presentProgressStatus;
      updateKeyValueMap["updated_at"] = new Date(
        moment().local().format("YYYY-MM-DD HH:mm:ss"),
      );

      this.$emit("updateValue", this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-order-type {
  .outer-area {
    padding: 1rem;
    flex-direction: column;
  }
  .candidate-list {
    margin: 0.2rem;
    min-height: 6rem;
  }
  .candidate-item {
    min-width: 5rem;
    padding-left: 0 !important;
    padding-right: 0 !important;

    width: 230px;
    height: 46px;
    margin: 0 1rem;
    border-radius: 8px;
  }

  ::v-deep .vs-input-number--button-less {
    display: none !important;
  }
  ::v-deep .vs-input-number--button-plus {
    display: none !important;
  }

  .button {
    width: 230px;
    height: 46px;
    margin: 0 1rem;
    border-radius: 8px;
    cursor: pointer;
  }

  .button-text {
    width: 32px;
    height: 24px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */
    align-items: center;
    text-align: center;

    color: #f2f2f2;
  }
  .text-input {
    width: 230px;
    height: 46px;
    margin: 0 1rem;
    border-radius: 8px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;

    align-items: center;
    display: flex;
    text-align: center;

    color: #4f4f4f;
    background-color: #f2f2f2;
    border: none;
  }

  .time-input-area {
    width: 230px;
    height: 46px;
    margin: 0.2rem 1rem 0.2rem 1rem !important;
    border-radius: 8px;
    display: flex;
    align-items: center;
  }
  .time-input {
    width: 16px;
    height: 46px;
    color: #4f4f4f;
    background-color: #f2f2f2;
    border: none;
    text-align: center;
  }
}
</style>
